// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__D9ug8","hidden":"Modal_hidden__ZnuQ1","modal_dialog":"Modal_modal_dialog__RDdt4","modal_content":"Modal_modal_content__uk3+N"};